import * as React from "react";
import { IconButton, Menu, MenuItem, ListItemText, ListItemIcon } from "@mui/material";
import { useState } from "react";
import { Check, Translate } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const languages = [
    { code: "en", label: "A" },
    { code: "zh_hk", label: "繁" },
    { code: "zh_cn", label: "簡" },
  ];

  return (
    <div>
      <IconButton color='inherit' onClick={handleClick}>
        <Translate />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {languages.map((language) => (
          <MenuItem key={language.code} onClick={() => handleLanguageChange(language.code)}>
            <ListItemText primary={language.label} />
            {i18n.language === language.code && (
              <ListItemIcon>
                <Check />
              </ListItemIcon>
            )}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default LanguageSwitcher;
